<template>
  <v-expansion-panels class="mb-4">
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm Zalo</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0 overflow-visible" outlined>
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="overflow-visible pa-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="filterForm.keyword"
                    label="Tìm kiếm theo tên, SĐT Zalo của khách hàng"
                    placeholder="Tìm kiếm theo tên/SĐT..."
                    clearable
                    @keyup.enter="searchZaloContact"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="filterForm.status"
                    :items="[
                      {'value': 0, 'text': 'Chưa khớp thông tin'},
                      {'value': 3, 'text': 'Có SĐT chưa khớp'}
                    ]"
                    label="Chọn trạng thái"
                    placeholder="--Chọn trạng thái--"
                    color="primary"
                    clearable
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                  class="primary mx-0"
                  @click="searchZaloContact"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  export default {
    name: 'FilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
      searchZaloContact () {
        Bus.$emit('zalo-list-filter', this.filterForm)
      },
    },
  }
</script>
